<template>
	<div>
			<div style="margin-top: 5em;margin-bottom:4em;text-align:center;">
			<img src="/img/huazhi_logo.png" /><br/>
			</div>
			
			
	<van-form>
	  <van-field
	    v-model="telephone"
	    name="手机号"
	    label="手机号"
	    placeholder="手机号"
	    :rules="[{ required: true, message: '请填写手机号' }]"
	  />
	  
	  <van-field
	    v-model="checkcode"
	    center
	    clearable
	    label="短信验证码"
	    placeholder="请输入短信验证码"
	  >
	    <template #button>
	      <van-button size="small" color="#09bb07" @click="smssend">发送验证码</van-button>
	    </template>
	  </van-field>
	  
	  <div style="margin: 16px;">
	    <van-button round block color="#09bb07"  @click="register">
	      注册并与微信账户绑定
	    </van-button>
	  </div>
	</van-form>
	</div>
</template>

<script>
		import {api_user} from '@/common/Request.js'
		import { Toast } from 'vant'
		import {CookieTool} from '@/utils/cookietool'
	export default {
	data () {
	  return {
	    telephone: '',
		checkcode:'',
		password2:'',
		password:'',
		usertoken:'',
		qd:''
	  }
	},
	methods:{
		register(){
			if(this.inputcheck()){
        this.telephone=this.telephone.trim();
		if(CookieTool.getCookie("huazhi_qd")!=''){
			this.qd=CookieTool.getCookie("huazhi_qd");
		}
		api_user.wxregister(this.$route.query.openid,this.telephone,this.checkcode,this.qd).then(response => {
				console.log(response);
				if(response.code==0)
				{
					this.usertoken=response.data.token;
					this.$cookies.set("user_token",response.data.token);
					this.$cookies.set("nickName",response.data.nickName);
					this.$cookies.set("mobilephone",response.data.mobile);
					this.$cookies.set("userId",response.data.userId);
					if(this.$cookies.isKey("beforeLoginUrl"))
					{
						this.$router.push(this.$cookies.get("beforeLoginUrl"));
					}
					else
					{
						this.$router.push('/usercenter');
					}

					Toast.success('成功！');
				}
				else{
					Toast.fail(response.msg);
				}


			});
			}
			else{
				Toast.fail('请填写手机号！')
			}
		},
		inputcheck(){
			if(this.telephone!='')
			{
				return true;
			}
			else{
				return false;
			}
		},
		smssend(){
			if(this.telephone!=''){
			api_user.smssend(this.telephone).then(response => {
				console.log(response);
				Toast.success('验证码发送成功！');
			});
			}
			else{
				Toast.fail('请先填写手机号！')
			}
		}
	}
	}
</script>

<style>
</style>
